import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import 'moment/locale/es';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTicketAlt, faPlus, faMoneyBillAlt, faInfoCircle, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { Form, Row, Col, Button, Badge, Modal } from "react-bootstrap";
import LoaderButton from "components/LoaderButton";

import { useAnalytics } from "libs/analytics";
import { useCart } from "libs/cartLib";
import { useAppContext } from "libs/contextLib";
import { Notification } from "libs/errorLib";
import Moment from "react-moment";
// import { useOrder } from "libs/ordersLib";
import './ShowTickets.css'

export default function ShowTickets(props) {
    const { show, viewerShow, notifyTicketChange, showAddToCart: showAddToCart = true, 
        quickBuyLink: quickBuyLink = false, paymentType = null, ...otherProps } = props

    const history = useHistory();
    const [tickets, setTickets] = useState(null)
    const [totalTickets, setTotalTickets] = useState(0)
    const [orderTotal, setOrderTotal] = useState(0);
    const [orderDiscountTotal, setOrderDiscountTotal] = useState(0);
    const [orderFeeTotal, setOrderFeeTotal] = useState(0);
    const [currency, setCurrency] = useState(show?.settings?.currency || 'GTQ')
    const [isLoading, setIsLoading] = useState(false);

    const { trackEvent } = useAnalytics();
    const { getCart, addCartItems, removeCartItems } = useCart()
    const { updateCartCounter } = useAppContext()

    // Check if this is for registration/free tickets
    const isRegistrationTicket = paymentType === 'REGISTRATION' || (tickets && tickets.length > 0 && tickets[0].payment_type && tickets[0].payment_type.includes('REGISTRATION'))

    // Check if single ticket mode is enabled
    const isSingleTicketMode = show?.settings?.single_ticket === true

    useEffect( () => {
        setTickets(props.tickets)        
        setOrderTotal(0)
        setTotalTickets(0)
        
        if (notifyTicketChange) {
            notifyTicketChange(null, 0, 0, currency)
        }
    }, [props.tickets])
    
    function applyPriceRule(t) {
        if (t.price_rules && t.price_rules.length > 0 && t.price_rules[0].rule_type == 'quantity_discount') {
            const rule = t.price_rules[0]
            if (t.selected >= rule.quantity_min) {
                const discount_price = rule.item_discount_price
                const subtotal_price = discount_price > 0 ? t.selected * discount_price : 0
                return subtotal_price
            }
        }
        return 0
    }


    function getActiveFeeForTicket(ticket, pt) {
        const isCard = pt === 'CREDIT_CARD';
        const isBank = pt === 'BANK_DEPOSIT' || pt === 'ACCOUNT_BANK_DEPOSIT';
        if (isCard) return (!ticket.fee || ticket.fee_included) ? null : Number(ticket.fee);
        if (isBank) return (!ticket.fee_other || ticket.fee_other_included) ? null : Number(ticket.fee_other);
        // No paymentType: show whichever fee applies
        if (ticket.fee && !ticket.fee_included) return Number(ticket.fee);
        if (ticket.fee_other && !ticket.fee_other_included) return Number(ticket.fee_other);
        return null;
    }

    function handleTicketSelection(event, id) {
        let total = 0
        let feeTotal = 0
        let effective_total = 0
        let hasDiscount = false
        let count = 0
        let currency = 'Q'
        let updated = tickets.map(t => {
            if (t._id === id) {
                t.selected = event.target.value
            }

            total += t.price * t.selected
            const activeFee = getActiveFeeForTicket(t, paymentType)
            if (activeFee) feeTotal += activeFee * Number(t.selected)
            count += Number(t.selected)
            currency = t.currency || show?.settings?.currency || 'GTQ'

            const ticketDiscountSubtotal = applyPriceRule(t)
            if (ticketDiscountSubtotal > 0) {
                hasDiscount = true
                effective_total += ticketDiscountSubtotal
            } else {
                effective_total += t.price * Number(t.selected)
            }

            return t
        })
        const discount_total = hasDiscount ? effective_total : 0
        setTickets(updated)
        setOrderTotal(total)
        setOrderFeeTotal(feeTotal)
        setOrderDiscountTotal(discount_total)
        setTotalTickets(count)
        setCurrency(currency)

        if (notifyTicketChange) {
            notifyTicketChange(updated, count, total, discount_total, currency)
        }
    } 

    function validateOrderForm() {
        return totalTickets > 0
    }

    async function handleAddToCartButton() {        
        registerCartItem(true)
    }

    async function handlePurchaseButton(addToCartOnly) {
        registerCartItem(false)
    }

    async function registerCartItem(addToCartOnly) {
        setIsLoading(true)
        if (addToCartOnly) {
            trackEvent({
                action: "Clicked Add to Cart Button",
                category: "PurchaseFunnel"
            });
        } else {
            trackEvent({
                action: "Clicked Buy Now Button",
                category: "PurchaseFunnel"
            });
        }

        const currency = show?.settings?.currency || 'GTQ'

        const items = tickets.filter(t => parseInt(t.selected) > 0 ).map(t => {
            const date = moment(show.show_date).format('ddd, LL - LT')

            const cartItem = {
                ticket_uid: t._id,
                type: 'TICKET',                
                show_uid: show._id,
                show_name: show.fullname,
                show_date: show.show_date,
                show_type: show.type,
                venue: show.venue,                
                title: `${show.fullname} (${date})`,
                description: t.fullname,
                note: t.note,
                ticket_type: t.type,
                image: `${show.main_image}`,
                quantity: parseInt(t.selected),                
            }
            console.log('items', t.bundle)
            if (t.bundle && t.bundle.length > 0) {
                cartItem.bundle_items = t.bundle.map(item => {
                    const it = {
                        ticket_uid: item._id,
                        code: item.code,
                        type: 'TICKET',
                        show_uid: show._id,
                        show_name: show.fullname,
                        show_date: show.show_date,
                        show_type: show.type,
                        venue: show.venue,
                        description: item.fullname,
                        note: item.note,
                        ticket_type: item.type,
                        image: `${show.main_image}`,
                        quantity: item.ammount * parseInt(t.selected)
                    }
                    if (item.location) {
                        it.location = item.location
                    }
                    if (item.ticket_image) {
                        it.ticket_image = item.ticket_image
                    }
                    if (item.qr_color) {
                        it.qr_color = item.qr_color
                    }
                    return it
                })
            }
            if (t.location) {
                cartItem.location = t.location
            } else {
                cartItem.location = {}
            }

            return cartItem
        })
        try {
            await addCartItems({
                currency: currency,
                items: items,
                payment_provider: show?.settings?.payment_provider,
                ...(show?.settings?.recurrente_account_id && { recurrente_account_id: show.settings.recurrente_account_id })
            })
            await updateCartCounter()
            if (addToCartOnly) {
                history.push('/cart',{})
            } else {
                history.push('/cart/checkout')
            }
        } catch(e) {
            if (e.response.status == 400) {                
                Notification('error', 'No fue posible agregar los boletos al carrito')
                history.push('/cart',{})
            } else {
                Notification('error', 'No fue posible agregar los boletos al carrito')
                history.push('/cart',{})
            }
        } finally {
            setIsLoading(false)
        }

    }

    // Add new function for single ticket selection
    async function handleSingleTicketSelection(ticket) {
        setIsLoading(true);
        
        trackEvent({
            action: "Selected Single Ticket",
            category: "PurchaseFunnel",
            label: ticket.fullname
        });

        const currency = show?.settings?.currency || 'GTQ';
        const date = moment(show.show_date).format('ddd, LL - LT');

        const cartItem = {
            ticket_uid: ticket._id,
            type: 'TICKET',                
            show_uid: show._id,
            show_name: show.fullname,
            show_date: show.show_date,
            show_type: show.type,
            venue: show.venue,                
            title: `${show.fullname} (${date})`,
            description: ticket.fullname,
            note: ticket.note,
            ticket_type: ticket.type,
            image: `${show.main_image}`,
            quantity: 1,
        };

        // Handle bundle items if present
        if (ticket.bundle && ticket.bundle.length > 0) {
            cartItem.bundle_items = ticket.bundle.map(item => {
                const it = {
                    ticket_uid: item._id,
                    code: item.code,
                    type: 'TICKET',
                    show_uid: show._id,
                    show_name: show.fullname,
                    show_date: show.show_date,
                    show_type: show.type,
                    venue: show.venue,
                    description: item.fullname,
                    note: item.note,
                    ticket_type: item.type,
                    image: `${show.main_image}`,
                    quantity: item.ammount
                };
                if (item.location) it.location = item.location;
                if (item.ticket_image) it.ticket_image = item.ticket_image;
                if (item.qr_color) it.qr_color = item.qr_color;
                return it;
            });
        }

        if (ticket.location) {
            cartItem.location = ticket.location;
        } else {
            cartItem.location = {};
        }

        try {
            await addCartItems({
                currency: currency,
                items: [cartItem],
                payment_provider: show?.settings?.payment_provider,
                ...(show?.settings?.recurrente_account_id && { recurrente_account_id: show.settings.recurrente_account_id })
            });
            await updateCartCounter();
            history.push('/cart/checkout');
        } catch(e) {
            if (e.response?.status === 400) {                
                Notification('error', 'No fue posible agregar el boleto al carrito');
            } else {
                Notification('error', 'No fue posible agregar el boleto al carrito');
            }
        } finally {
            setIsLoading(false);
        }
    }

    function renderTicketFeeInfo(ticket) {
        const activeFee = getActiveFeeForTicket(ticket, paymentType);
        if (!activeFee) return null;
        const cur = ticket.currency === 'USD' ? 'US$' : 'Q';
        return (
            <div className="ticket-fee-info">+ {cur} {activeFee.toFixed(2)} cargo por servicio</div>
        );
    }

    function renderTickets() {
        // <Col md="2">{!viewerShow ? <Button variant="primary" data-ticket-id={t.id} onClick="">Comprar</Button> : null }</Col>
        const now = moment.utc()

        let items = [];
        if (tickets) {
            items = tickets.filter( t => {
                    return t.visible
                }).map( t => {
                    const since = moment.utc(t.valid_since);
                    const thru = t.valid_thru ? moment.utc(t.valid_thru) : now

                    t.since = since
                    t.thru = thru
                    t.expired = now.isAfter(thru)
                    t.can_buy = now.isSameOrAfter(since)
                    return t
                })
                .map( t => {
                    let options = []
                    const maxQuantity = show?.settings?.max_ticket_quantity || 10
                    for(let i = 0; i <= maxQuantity && i <= t.real_available; i++) {
                        options.push(<option value={`${i}`} key={`${t.ticket_id}-${i}`}>{`${i}`}</option>)
                    }

                    let disclaimer = null;
                    let selector = null;
                    if (t.expired) {
                        disclaimer = <span className="ticket-soldout">AGOTADOS</span>;
                    } else if (t.can_buy) {
                        if (t.real_available > 0) {
                            if (t.show_dates && t.show_dates.length > 1) {
                                selector = (
                                    <select className="ticket-showdates">
                                        {t.show_dates.map((date, idx) => (
                                            <option key={idx} value={date.value}>{date.label}</option>
                                        ))}
                                    </select>
                                );
                            } else {
                                selector = (
                                    <Form.Control as="select" value={t.selected} onChange={(e) =>handleTicketSelection(e, t._id)} className="ticket-selector">
                                        { options }
                                    </Form.Control>
                                );
                            }
                        } else {
                            disclaimer = <span className="ticket-soldout">AGOTADOS</span>;
                        }
                    } else {
                        disclaimer = <span className="ticket-future">Disponible a partir del <Moment local format="lll">{t.since}</Moment></span>;
                    }

                    return (
                        <div className="ticket-card" key={t._id}>
                            <div className="ticket-card-row">
                                <div className="ticket-title">{t.fullname}</div>
                                <div className="ticket-price-group">
                                    <div className="ticket-price">
                                        {isRegistrationTicket ? "Acceso gratuito" : (t.currency == 'USD' ? t.price_usd_text : t.price_text)}
                                    </div>
                                    {!isRegistrationTicket && renderTicketFeeInfo(t)}
                                </div>
                            </div>
                            <div className="ticket-desc">{t.note ? <div className="note">{t.note}</div> : null}{t.description}</div>
                            <div className="ticket-card-row ticket-card-row--footer">
                                <div className="ticket-disclaimer">{disclaimer}</div>
                                <div className="ticket-card-control">{selector}</div>
                            </div>
                        </div>
                    );
                })
        } else {         
            items.push( <Row>
                <Col><Badge variant="info" style={{fontWeight:'normal'}}>Pr&oacute;ximamente</Badge></Col>                                
            </Row> )
        }
        const buyText = viewerShow ? "Comprar más" : "Comprar"
        const showTickets = ['ACTIVE','STARTED','LIVE','REPLAY','HIDDEN','TEST'].includes(show.status);

        if (['NEW','CLOSED'].includes(show.status)) {
            return null;
        }

        const cur = currency === 'USD' ? 'US$' : 'Q';
        return showTickets && tickets && tickets.length > 0 ? <>
            <div className="section-title"><span className="section-title__accent" />Boletos</div>
             {items}

                {!isRegistrationTicket && totalTickets > 0 && (
                    <div className="tickets-breakdown">
                        <div className="tickets-breakdown-row">
                            <span className="tickets-breakdown-label">Boletos ({totalTickets})</span>
                            <span className="tickets-breakdown-value">
                                {orderDiscountTotal > 0 ? (
                                    <>
                                        <span style={{textDecoration: 'line-through', opacity: 0.6}}>
                                            {cur} {orderTotal.toFixed(2)}
                                        </span>
                                        {' '}{cur} {orderDiscountTotal.toFixed(2)}
                                    </>
                                ) : (
                                    <>{cur} {orderTotal.toFixed(2)}</>
                                )}
                            </span>
                        </div>
                        {orderFeeTotal > 0 && (
                            <div className="tickets-breakdown-row">
                                <span className="tickets-breakdown-label">Cargo por servicio</span>
                                <span className="tickets-breakdown-value">+ {cur} {orderFeeTotal.toFixed(2)}</span>
                            </div>
                        )}
                        <div className="tickets-breakdown-total">
                            <span className="tickets-breakdown-total-label">TOTAL</span>
                            <span className="tickets-breakdown-total-value">
                                {cur} {((orderDiscountTotal > 0 ? orderDiscountTotal : orderTotal) + orderFeeTotal).toFixed(2)}
                            </span>
                        </div>
                    </div>
                )}

                { showAddToCart && <LoaderButton className="tickets-addtocart-btn"
                        disabled={!validateOrderForm()}
                        isLoading={isLoading}
                        onClick={handleAddToCartButton}><FontAwesomeIcon icon={faPlus} /> Agregar al Carrito</LoaderButton> }
                <Row className="tickets-footer"><Col className="note">**Recibirás un correo por cada boleto en el correo electrónico registrado en el siguiente formulario</Col></Row>
                
                {/* : <Row><Col><Badge variant="info" style={{fontWeight:'normal'}}>Pr&oacute;ximamente</Badge></Col></Row> } */}
            </> : <></>

    }

    function renderSingleTicketSelection() {
        const now = moment.utc();

        if (!tickets || tickets.length === 0) {
            return (
                <div className="section-title">
                    <span className="section-title__accent" />
                    Boletos
                    <div className="single-ticket-empty">
                        <Badge variant="info" style={{fontWeight:'normal'}}>Próximamente</Badge>
                    </div>
                </div>
            );
        }

        const availableTickets = tickets
            .filter(t => t.visible)
            .map(t => {
                const since = moment.utc(t.valid_since);
                const thru = t.valid_thru ? moment.utc(t.valid_thru) : now;

                t.since = since;
                t.thru = thru;
                t.expired = now.isAfter(thru);
                t.can_buy = now.isSameOrAfter(since);
                return t;
            });

        return (
            <>
                <div className="section-title">
                    <span className="section-title__accent" />
                    Selecciona tu boleto
                </div>
                <div className="single-ticket-subtitle">
                    Toca el boleto que deseas comprar
                </div>
                
                <div className="single-ticket-grid">
                    {availableTickets.map(ticket => {
                        const isAvailable = ticket.can_buy && !ticket.expired && ticket.real_available > 0;
                        
                        return (
                            <div 
                                key={ticket._id}
                                className={`single-ticket-card ${isAvailable ? 'single-ticket-card--available' : 'single-ticket-card--unavailable'}`}
                                onClick={isAvailable ? () => handleSingleTicketSelection(ticket) : undefined}
                            >
                                <div className="single-ticket-card-header">
                                    <div className="single-ticket-title">{ticket.fullname}</div>
                                    <div className="single-ticket-price">
                                        {isRegistrationTicket ? "Acceso gratuito" : (ticket.currency === 'USD' ? ticket.price_usd_text : ticket.price_text)}
                                    </div>
                                </div>
                                
                                <div className="single-ticket-description">
                                    {ticket.note && <div className="single-ticket-note">{ticket.note}</div>}
                                    {ticket.description}
                                </div>

                                {isAvailable ? (
                                    <div className="single-ticket-action">
                                        <FontAwesomeIcon icon={faArrowRight} />
                                        <span>{isRegistrationTicket ? "Registrarse" : "Comprar 1 boleto"}</span>
                                    </div>
                                ) : (
                                    <div className="single-ticket-status">
                                        {ticket.expired ? (
                                            <span className="single-ticket-soldout">AGOTADO</span>
                                        ) : (
                                            <span className="single-ticket-future">
                                                Disponible desde <Moment local format="ll">{ticket.since}</Moment>
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                {isLoading && (
                    <div className="single-ticket-loading">
                        <div className="loading-spinner"></div>
                        <span>Procesando...</span>
                    </div>
                )}
            </>
        );
    }

    function renderTotal() {
        if (isRegistrationTicket) {
            return ""; // Don't show total for registration tickets
        }
        
        if (orderDiscountTotal > 0) {
            return <><span style={{textDecoration:'line-through'}}>{currency} {orderTotal}</span> {currency} {orderDiscountTotal}</>
        } else {
            return <>{currency} {orderTotal}</>
        }
    }

    function renderQuickBuyLink() {
        return <div class="quickbuy_link">
            <a href={show.settings.quickbuy_link} target="_blank">                
                <FontAwesomeIcon icon={faMoneyBillAlt} />
                <span>Registra aquí tu pago con depósito o transferencia bancaria<br />{show.settings.quickbuy_link}</span>                
            </a>
        </div>
    }

    function render() {        
        if (quickBuyLink) {
            return renderQuickBuyLink()
        } else if (isSingleTicketMode) {
            return renderSingleTicketSelection()
        } else {
            return renderTickets()
        }
    }
    return render()
}